import barPin from "../images/pin-bar.png";
import restaurantPin from "../images/pin-restaurant.png";
import storePin from "../images/pin-store.png";
import otherPin from "../images/pin-other.png";
import hotelPin from "../images/pin-hotel.png";

import { Bar, Restaurant, Store, Other } from "../icons";
import { palette } from "../ui-components";

/**
 * Returns the RGB/RGBA value for a given hex color code
 * @param {string} hex
 * @param {float} alpha
 */
export function hexToRGB(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);
  return alpha ? `rgba(${r}, ${g}, ${b}, ${alpha})` : `rgba(${r}, ${g}, ${b})`;
}

/**
 * Returns the correct category based on the database category (place detail icon filename)
 * @param {string} category
 */
export function getCorrectCategory(category) {
  switch (category) {
    case "restaurant-71":
      return "restaurant";
    case "bar-71":
      return "bar";
    case "supermarket-71":
      return "store";
    case "shopping-71":
      return "store";
    default:
      return "other";
  }
}

export function getFileName(str) {
  const filename = str.split("\\").pop().split("/").pop();
  return filename.split(".").slice(0, -1).join(".");
}

/**
 * Returns the correct map icon (PNG) based on the category
 * @param {string} category
 */
export function getMapIcon(category) {
  switch (category) {
    case "restaurant":
      return restaurantPin;
    case "bar":
      return barPin;
    case "store":
      return storePin;
    case "hotel":
      return hotelPin;
    default:
      return otherPin;
  }
}

/**
 * Returns the correct category icon (SVG) based on the category
 * @param {string} category
 */
export function getCategoryIcon(category) {
  switch (category) {
    case "restaurant":
      return <Restaurant />;
    case "bar":
      return <Bar />;
    case "store":
      return <Store />;
    default:
      return <Other />;
  }
}

/**
 * Returns the correct category icon (SVG) based on the category
 * @param {string} category
 */
export function getCategoryColor(category) {
  switch (category) {
    case "restaurant":
      return palette.orange;
    case "bar":
      return palette.green;
    case "store":
      return palette.blue;
    default:
      return palette.purple;
  }
}

/**
 * Convert kilometers to miles
 * @param {number} distance
 */
export function kmToMiles(distance) {
  return (distance / 1.60934).toFixed(1);
}

export function fbpolygon() {
  const coords =
    "-96.937877,32.914427 -96.937376,32.915442 -96.937279,32.917147 -96.937662,32.918352 -96.937864,32.919241 -96.937576,32.920036 -96.937284,32.921025 -96.929675,32.921038 -96.929632,32.918188 -96.92921,32.91816 -96.925726,32.918028 -96.925229,32.918028 -96.92527,32.919258 -96.925294,32.92075 -96.924378,32.920802 -96.924547,32.923896 -96.919537,32.923834 -96.91952,32.924473 -96.920128,32.924422 -96.920147,32.926909 -96.920311,32.930629 -96.910688,32.930639 -96.91091,32.939168 -96.910073,32.939176 -96.908918,32.939138 -96.90605,32.939377 -96.905412,32.939402 -96.904035,32.939334 -96.902747,32.939307 -96.900618,32.939158 -96.896574,32.939158 -96.893271,32.939138 -96.890569,32.939084 -96.890519,32.94073 -96.890523,32.941449 -96.890503,32.94229 -96.890454,32.943196 -96.890418,32.946374 -96.886064,32.946402 -96.884324,32.946367 -96.884062,32.946348 -96.882396,32.946326 -96.87666,32.946313 -96.874921,32.946294 -96.874264,32.946308 -96.873516,32.946362 -96.871899,32.94635 -96.87146,32.947211 -96.871219,32.947803 -96.871134,32.948042 -96.871071,32.948338 -96.870966,32.948513 -96.870915,32.948805 -96.870818,32.949596 -96.870769,32.95198 -96.870721,32.953381 -96.870309,32.953338 -96.868562,32.953311 -96.865577,32.953296 -96.864948,32.95328 -96.864197,32.953232 -96.863248,32.953211 -96.861154,32.95317 -96.858915,32.953158 -96.856194,32.953104 -96.855801,32.953083 -96.855788,32.950176 -96.855807,32.949605 -96.855807,32.947968 -96.855829,32.947105 -96.855836,32.945729 -96.855896,32.942402 -96.855876,32.94129 -96.855951,32.934834 -96.855937,32.933678 -96.855914,32.933293 -96.85575,32.933304 -96.851495,32.933214 -96.847031,32.933154 -96.846978,32.935986 -96.846934,32.939873 -96.845726,32.939861 -96.843796,32.939881 -96.842657,32.939875 -96.840938,32.939839 -96.838854,32.939855 -96.838874,32.941231 -96.838875,32.943461 -96.838841,32.94435 -96.838822,32.945929 -96.838832,32.949219 -96.838791,32.950702 -96.8388,32.951326 -96.831875,32.951323 -96.831986,32.947325 -96.828281,32.94722 -96.82616,32.947333 -96.825861,32.941947 -96.823919,32.941822 -96.822229,32.941736 -96.822255,32.939492 -96.822236,32.938707 -96.822341,32.937863 -96.822351,32.937251 -96.822331,32.936863 -96.822332,32.935696 -96.822292,32.935383 -96.822264,32.933974 -96.822176,32.932909 -96.822509,32.932923 -96.821606,32.929369 -96.82147,32.928139 -96.821546,32.928057 -96.821573,32.927587 -96.821544,32.927485 -96.82174,32.927442 -96.822076,32.927311 -96.822351,32.92716 -96.822815,32.926847 -96.82316,32.926665 -96.823312,32.9266 -96.823649,32.926518 -96.823975,32.926493 -96.825512,32.926465 -96.826884,32.926411 -96.828014,32.92644 -96.828671,32.926436 -96.829529,32.926399 -96.830087,32.926344 -96.830945,32.926337 -96.833424,32.926363 -96.83441,32.926363 -96.834982,32.926346 -96.836422,32.926192 -96.837161,32.926094 -96.837968,32.925936 -96.838771,32.925735 -96.839682,32.925381 -96.840019,32.925206 -96.841148,32.924554 -96.842143,32.924076 -96.84311,32.923572 -96.850607,32.920434 -96.852985,32.919414 -96.8559,32.918213 -96.857328,32.917583 -96.858975,32.91695 -96.859312,32.916894 -96.860346,32.916646 -96.861671,32.916386 -96.861966,32.91635 -96.864776,32.915497 -96.866442,32.915121 -96.867356,32.914889 -96.868291,32.914624 -96.868652,32.914458 -96.870593,32.913807 -96.870968,32.913657 -96.87316,32.913097 -96.878177,32.912008 -96.881551,32.9112 -96.887552,32.909891 -96.890856,32.909095 -96.891566,32.909565 -96.891468,32.909666 -96.891434,32.911306 -96.891398,32.915553 -96.894041,32.915309 -96.894059,32.915376 -96.894378,32.915316 -96.89463,32.915319 -96.894523,32.914972 -96.894384,32.914633 -96.894386,32.914606 -96.894274,32.914365 -96.898593,32.914397 -96.898602,32.913865 -96.900064,32.913828 -96.900067,32.913906 -96.90154,32.913877 -96.901748,32.913861 -96.902679,32.913737 -96.904309,32.91336 -96.904988,32.913265 -96.904833,32.912213 -96.904766,32.911971 -96.904674,32.911719 -96.908243,32.911788 -96.909018,32.907916 -96.909259,32.90661 -96.909867,32.903971 -96.910693,32.899741 -96.910022,32.899737 -96.910656,32.896254 -96.910726,32.89602 -96.910874,32.89586 -96.911491,32.895688 -96.912789,32.895708 -96.914656,32.895649 -96.916667,32.895663 -96.918833,32.895629 -96.919993,32.895638 -96.92486,32.895587 -96.924963,32.895626 -96.927288,32.895668 -96.92693,32.896721 -96.922958,32.897185 -96.921658,32.8977 -96.92073,32.899952 -96.922571,32.900371 -96.925071,32.899783 -96.92637,32.899988 -96.926186,32.902869 -96.92647,32.904815 -96.928171,32.90641 -96.930177,32.906917 -96.931182,32.907519 -96.930244,32.909249 -96.930402,32.909671 -96.930675,32.910735 -96.931584,32.911523 -96.933267,32.912618 -96.935169,32.912722 -96.937696,32.913851 -96.937877,32.914427";

  return coords.split(" ").map((item) => {
    const values = item.split(",");
    return {
      lat: Number(values[1]),
      lng: Number(values[0]),
    };
  });
}

/**
 * Returns city, state, and zip by geo coordinates
 *
 * @param {number} lat
 * @param {number} lng
 */
export function getLocationDetailsByGeo(lat, lng) {
  return new Promise((resolve, reject) => {
    if (window.google) {
      const geocoder = new window.google.maps.Geocoder();
      const latlng = new window.google.maps.LatLng(lat, lng);
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          if (results.length > 1) {
            const filtered = results.filter(
              (result) => result.types[0] === "postal_code"
            );
            if (filtered.length > 0) {
              const zipCode = filtered[0].address_components[0].long_name;
              const city = filtered[0].address_components[1].long_name;
              const state = filtered[0].address_components[3].short_name;
              resolve({
                zipCode,
                city,
                state,
              });
            }
          }
        } else {
          reject("Geocoder failed due to: " + status);
        }
      });
    } else {
      reject("Something went wrong");
    }
  });
}

//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::                                                                         :::
//:::  This routine calculates the distance between two points (given the     :::
//:::  latitude/longitude of those points). It is being used to calculate     :::
//:::  the distance between two locations using GeoDataSource (TM) prodducts  :::
//:::                                                                         :::
//:::  Definitions:                                                           :::
//:::    South latitudes are negative, east longitudes are positive           :::
//:::                                                                         :::
//:::  Passed to function:                                                    :::
//:::    lat1, lon1 = Latitude and Longitude of point 1 (in decimal degrees)  :::
//:::    lat2, lon2 = Latitude and Longitude of point 2 (in decimal degrees)  :::
//:::    unit = the unit you desire for results                               :::
//:::           where: 'M' is statute miles (default)                         :::
//:::                  'K' is kilometers                                      :::
//:::                  'N' is nautical miles                                  :::
//:::                                                                         :::
//:::  Worldwide cities and other features databases with latitude longitude  :::
//:::  are available at https://www.geodatasource.com                         :::
//:::                                                                         :::
//:::  For enquiries, please contact sales@geodatasource.com                  :::
//:::                                                                         :::
//:::  Official Web site: https://www.geodatasource.com                       :::
//:::                                                                         :::
//:::               GeoDataSource.com (C) All Rights Reserved 2018            :::
//:::                                                                         :::
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

export function calcDistance(lat1, lon1, lat2, lon2, unit) {
  if (lat1 === lat2 && lon1 === lon2) {
    return 0;
  } else {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit === "K") {
      dist = dist * 1.609344;
    }
    if (unit === "N") {
      dist = dist * 0.8684;
    }
    return dist;
  }
}
